// pt-BR of the codebase analysis; complete for every key of en-onboarding.ts (checked by the type).
import type { enOnboarding } from "./en-onboarding.ts";

export const ptBROnboarding: Record<keyof typeof enOnboarding, string> = {
  "onboarding.completion": "{percent}% concluído",
  "onboarding.completionDetail": "{implemented} de {mandatory} obrigatórios · {partial} parciais",
  "onboarding.codeColumn": "Código",
  "onboarding.notAnalysed": "Não analisado",
  "onboarding.verdict.implemented": "Implementado",
  "onboarding.verdict.partial": "Parcial",
  "onboarding.verdict.not_found": "Não encontrado",
  "onboarding.verdict.uncertain": "Incerto",
  "onboarding.notHomologated": "não homologado",
  "onboarding.moreRefs": "+{count}",
  "onboarding.refsLabel": "Arquivos por trás do veredito",

  "onboarding.title": "Análise do código",
  "onboarding.intro": "Confere no repositório quais requisitos já estão implementados. Só caminhos de arquivo e intervalos de linhas são exibidos.",
  "onboarding.analyze": "Analisar o código",
  "onboarding.cancel": "Cancelar",
  "onboarding.state.queued": "Na fila",
  "onboarding.state.running": "Analisando",
  "onboarding.state.done": "Concluída",
  "onboarding.state.failed": "Falhou",
  "onboarding.state.cancelled": "Cancelada",
  "onboarding.counts": "{implemented} implementados · {partial} parciais · {uncertain} incertos · {not_found} não encontrados · {closed} fechadas",
  "onboarding.runError": "A análise parou: {error}",
  "onboarding.runSelect": "Execução da análise",
  "onboarding.cost": "Custo: {cost}",
  "onboarding.cause.disabled": "A análise do código está desligada na configuração deste projeto ou da organização.",
  "onboarding.cause.not_attested": "Falta a declaração do administrador da organização (Integrações › Conexões).",
  "onboarding.cause.no_repository": "Este projeto ainda não tem repositório preparado no worker.",
  "onboarding.cause.no_jev_connection": "A organização não tem conexão Jev configurada.",
  "onboarding.cause.unavailable": "O motor de execução está indisponível agora; tente mais tarde.",
  "onboarding.cause.analysis_running": "A análise ainda está rodando: responda quando ela terminar.",
  "onboarding.cause.no_machine_verdict": "Esta análise não tem veredito para o requisito: não há o que responder.",
  "onboarding.cause.no_evidence": "Não há evidência no código para este requisito — rode a análise de novo ou marque como não está pronto.",
  "onboarding.cause.project_halted": "O projeto está pausado: nada é fechado enquanto ele continuar pausado.",

  "onboarding.review": "Para revisar",
  "onboarding.reviewEmpty": "Nada para revisar.",
  "onboarding.reason.uncertain": "O Jev não soube dizer",
  "onboarding.reason.would_close": "O Jev diz que já está implementado",
  "onboarding.openTasks": "Tarefas abertas",
  "onboarding.ready": "Pronto",
  "onboarding.notReady": "Não está pronto",
  "onboarding.readyFor": "Pronto — {code}",
  "onboarding.notReadyFor": "Não está pronto — {code}",
  "onboarding.skippedTitle": "Estas tarefas ficaram como estavam",
  "onboarding.skip.invalid_transition": "ela não está mais em Backlog, Em análise ou A fazer (só trabalho ainda não iniciado é fechado)",
  "onboarding.skip.children_pending": "ela tem subtarefas obrigatórias ainda abertas",
  "onboarding.skip.gate_pending": "ela tem verificações obrigatórias ainda pendentes",
  "onboarding.skip.dependencies_pending": "ela depende de tarefas ainda não concluídas",
  "onboarding.skip.shared_requirement_open": "ela também atende outro requisito ainda não coberto",
  "onboarding.skip.touched": "ela foi alterada depois que a análise a fechou",
  "onboarding.skip.not_existing": "ela não está mais fechada como já existente",
  "onboarding.answeredReady": "{code}: pronto. {count} tarefa(s) fechada(s).",
  "onboarding.answeredNotReady": "{code}: não está pronto. As tarefas continuam abertas.",
  "onboarding.dryRun": "Eu fecharia estas {count} tarefas",
  "onboarding.dryRunBody": "O fechamento automático estava desligado nesta análise: nada foi fechado. Responda Pronto num requisito para fechar as tarefas dele.",

  "onboarding.closed": "Fechadas pela análise",
  "onboarding.closedEmpty": "A análise não fechou nenhuma tarefa.",
  "onboarding.reopen": "Reabrir",
  "onboarding.reopenFor": "Reabrir — tarefa #{number}",
  "onboarding.reopenAll": "Reabrir fechadas por esta análise",
  "onboarding.reopenAllBody":
    "Toda tarefa que esta análise fechou e ninguém mexeu depois volta para o quadro, e o requisito dela deixa de contar como implementado. Tarefas alteradas depois do fechamento ficam como estão.",
  "onboarding.reopenedCount": "{count} tarefa(s) reaberta(s).",
  "onboarding.taskReopened": "Tarefa #{number} reaberta.",

  "onboarding.existingPill": "Já existia",
  "onboarding.reopenExistingBody": "Esta tarefa foi fechada porque o código já existia. Reabrir a devolve para o quadro.",
  "onboarding.startedDependents": "Estas tarefas dependem dela e já começaram; elas não serão pausadas",

  "onboarding.attestation.title": "Análise do código: envio de código a terceiro",
  "onboarding.attestation.text":
    "Ao ativar a análise do código, trechos do repositório — até 6000 caracteres por requisito, sem arquivos de segredo e com dados sensíveis mascarados — são enviados à OpenRouter para o modelo Jev avaliar se cada requisito já está implementado.",
  "onboarding.attestation.checkbox": "Declaro que a organização tem o direito de enviar esse código a esse terceiro.",
  "onboarding.attestation.submit": "Registrar declaração",
  "onboarding.attestation.by": "Declarado por {name} em {date}",
  "onboarding.attestation.revoke": "Revogar",
  "onboarding.attestation.recorded": "Declaração registrada.",
  "onboarding.attestation.revoked": "Declaração revogada: nenhuma nova análise começa até ela ser registrada de novo.",

  "production.doneOfExisting": "{done} de {total} ({existing} já existiam)",

  "githubOnboarding.newFromGithub": "Novo projeto a partir do GitHub",
  "githubOnboarding.createDescription": "Escolha um repositório que a sua conexão do GitHub alcança: o projeto recebe o nome e a branch padrão dele e depois é clonado.",
  "githubOnboarding.connectTitle": "Conectar repositório",
  "githubOnboarding.connectDescription": "Escolha o repositório deste projeto no GitHub: ele é clonado, o comando de teste é detectado e o projeto é validado.",
  "githubOnboarding.connection": "Conexão do GitHub",
  "githubOnboarding.noConnection": "Ainda não há uma conexão do GitHub ativa.",
  "githubOnboarding.connectGithub": "Conectar GitHub",
  "githubOnboarding.repository": "Repositório",
  "githubOnboarding.filter": "Filtrar repositórios",
  "githubOnboarding.private": "Privado",
  "githubOnboarding.defaultBranch": "branch padrão {branch}",
  "githubOnboarding.noRepositories": "Esta conexão não alcança nenhum repositório.",
  "githubOnboarding.noMatch": "Nenhum repositório corresponde ao filtro.",
  "githubOnboarding.create": "Criar projeto",
  "githubOnboarding.connect": "Conectar",
  "githubOnboarding.created": "Projeto {name} criado: clonando o repositório.",
  "githubOnboarding.cardBody": "Este projeto ainda não tem uma cópia local do repositório. Conecte-o pelo GitHub: ele é clonado, o comando de teste é detectado e o projeto é validado.",
  "githubOnboarding.adminOnly": "Só um administrador da organização pode conectar um repositório.",
  "githubOnboarding.step.cloning": "Clonando",
  "githubOnboarding.step.detecting": "Detectando",
  "githubOnboarding.step.validating": "Validando",
  "githubOnboarding.stepState.done": "concluído",
  "githubOnboarding.stepState.current": "em andamento",
  "githubOnboarding.stepState.pending": "pendente",
  "githubOnboarding.failed": "Não foi possível conectar o repositório",
  "githubOnboarding.retry": "Tentar de novo",
  "githubOnboarding.testCommand": "Comando de teste: {command}",
  "githubOnboarding.noTestCommand": "Não encontramos o comando de teste — informe nas configurações",
  "githubOnboarding.checkingReadiness": "Verificando a prontidão…",
  "githubOnboarding.stillChecking": "A prontidão ainda está sendo verificada — tente Validar agora em instantes.",
  "githubOnboarding.operatorPending": "Política de execução: aguardando o operador",
  "githubOnboarding.error.too_large": "O repositório é grande demais para clonar aqui (limite de 1 GB).",
  "githubOnboarding.error.disk_low": "O servidor não tem espaço livre em disco suficiente para clonar este repositório.",
  "githubOnboarding.error.timeout": "A cópia do repositório passou de 10 minutos e foi interrompida.",
  "githubOnboarding.error.host_not_allowed": "Este endereço de repositório não é permitido: só repositórios do GitHub por HTTPS.",
  "githubOnboarding.error.auth_failed": "O GitHub recusou o acesso: confira se a conexão ainda alcança este repositório.",
  "githubOnboarding.error.not_found": "O repositório não foi encontrado no GitHub: ele pode ter sido renomeado, apagado ou tirado da conexão.",
  "githubOnboarding.error.base_branch_missing": "O repositório está vazio ou não tem a branch padrão.",
  "githubOnboarding.error.clone_failed": "A cópia do repositório falhou. Tente de novo.",
  "githubOnboarding.error.connection_unavailable": "O serviço que clona repositórios está indisponível agora. Tente de novo em instantes.",
  "githubOnboarding.error.not_git_root": "A pasta clonada não é a raiz de um repositório git.",
};
